<script setup lang="ts">
import { useModyApi } from "~/middelware/ModyApi";
import {onMounted} from "@vue/runtime-core";
import type {Category} from "~/utils/Category";
import type {MenuItem} from "primevue/menuitem";
import {useRouter} from "vue-router";


const api = useModyApi();
const menuItems = ref<MenuItem[]|undefined>([])
const router = useRouter();

function convertCategoriesToMenuItems(categories:Category[]):MenuItem[]|undefined{
  let nodes:MenuItem[] = []
  categories.forEach((category:Category)=>{
    const newNode:MenuItem = {
      key: String(category.id),
      label:category.name,
      command: ()=>{router.push("/shop/category/"+category.id)},
      items: convertCategoriesToMenuItems(category.subCategories),
      style: "background: none;",
    }
    if(newNode.items) newNode.command = undefined
    nodes.push(newNode)
  })
  if(nodes.length == 0) return undefined
  return nodes
}

onMounted(async ()=>{
  const categories = await api.getCategories();
  menuItems.value = convertCategoriesToMenuItems(categories)
})

</script>
<template>
    <div class="menuContainer">
      <div class="text-2xl bold">Sortiment</div>
      <div class="skeletons" v-if="menuItems.length == 0">
        <Skeleton width="10rem" height="2rem"></Skeleton>
        <Skeleton width="14rem" height="2rem"></Skeleton>
        <Skeleton width="12rem" height="2rem"></Skeleton>
        <Skeleton width="9rem" height="2rem"></Skeleton>
        <Skeleton width="10rem" height="2rem"></Skeleton>
      </div>
      <PanelMenu :model="menuItems"></PanelMenu>
    </div>
</template>
<style lang="scss" scoped>

.menuContainer{
  padding:0 20px 20px 20px;

  @include desktop(){
    margin: auto auto 200px;
    max-width:$desktop-content-width;
    padding: 0;
  }
}
.skeletons{
  .p-skeleton{
    margin-bottom:20px;
  }
}
:deep(.p-panelmenu-header-action){
  padding-left: 0;
}
:deep(.p-panelmenu-header-content){
  background: none;
  border: none;
}
:deep(.p-panelmenu-content){
  background: none;
  border: none;
}
:deep(.p-menuitem-link:visited){
  color: unset;
}

</style>
